var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible && +_vm.homeInfo.activityState === 2)?_c('div',{staticClass:"operate-outer"},[_c('div',{staticClass:"operate-inner"},[_c('div',{staticClass:"operate-btn",on:{"click":_vm.openShare}},[_vm._v("立即邀请")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }